import { Tabs } from "@mui/material";

export const MuiTabs = Tabs;
